import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles/index'
import ProjectSubItems from '../components/Project/ProjectSubItems'
import ProjectTextField from '../components/Project/ProjectTextField'
import ProjectSelectField from '../components/Project/ProjectSelectField'
import ProjectBreadcrumb from '../components/Project/ProjectBreadcrumb'
import queryString from 'query-string'
import Button from '@material-ui/core/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'

import {
    attachProjectSetting,
    createChildProjectSetting,
    createProjectSetting,
    deleteProjectSetting,
    detachProjectSetting,
    getProjectSettings,
    saveProjectSetting
} from '../api'
import Layout from '../components/Simple/Layout'
import TextEditor from '../components/Simple/TextEditor'

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    container: {
        maxWidth: 2000,
        margin: 'auto'
    },
    moreButton: {
        background: 'white',
        minWidth: 0,
        fontSize: '1.6rem'
    },
    loadingSpinner: {
        color: theme.palette.primary[500]
    }
})

class AdminProjectSettings extends PureComponent {
    state = {
        id: null,
        fields: null,
        breadcrumbs: null,
        moreSettings: false,
        currentPayload: null,
        previousPayload: null,
        isLoading: true
    }

    componentDidMount() {
        this.init()
        this.props.setPageTitle('Project Settings')
    }

    init = () => {
        const parsedQueryString = queryString.parse(window.location.search)

        this.setState(
            {
                rootItemType: parsedQueryString['itemType'],
                childItemType: parsedQueryString['childItemType'],
                childItemId: parsedQueryString['childItemId']
            },
            () => {
                this.update({
                    itemType: parsedQueryString['itemType'],
                    action: parsedQueryString['action'],
                    id: parsedQueryString['id'],
                    childItemType: parsedQueryString['childItemType'],
                    childItemId: parsedQueryString['childItemId']
                })
            }
        )
    }

    refresh = () => {
        this.update(this.state.currentPayload)
    }

    update = payload => {
        payload.rootItemType = this.state.rootItemType

        const updateState = response => {
            const fields = response.data.fields
            const id = response.data.id
            const breadcrumbs = response.data.breadcrumbs
            const itemType = response.data.itemType

            const newState = {
                fields: fields,
                id: id,
                breadcrumbs: breadcrumbs,
                itemType: itemType,
                moreSettings: false,
                currentPayload: payload,
                isLoading: false
            }
            this.setState(newState)
        }

        this.setState({ isLoading: true, config: null, previousPayload: this.state.currentPayload }, () => {
            getProjectSettings(payload).then(updateState)
        })
    }

    save = (id, alias, value, itemTypeAttr = null) => {
        const itemType = itemTypeAttr ? itemTypeAttr : this.state.itemType
        saveProjectSetting({ id: id, alias: alias, value: value, itemType: itemType })
    }

    create = itemType => {
        createProjectSetting({ itemType: this.state.itemType, id: this.state.id, subItemType: itemType }).then(response => {
            this.update({ itemType: itemType, id: response.id, action: 'edit' })
        })
    }

    createChildItem = (itemId, childOptionType, childOptionId) => {
        createChildProjectSetting({
            itemType: this.state.itemType,
            id: itemId,
            childItemType: this.state.childItemType,
            childItemId: this.state.childItemId,
            childOptionType: childOptionType,
            childOptionId: childOptionId
        }).then(response => {
            this.refresh()
        })
    }

    onChildItemValueChanged = (id, value, itemType, alias) => {
        saveProjectSetting({ id: id, alias: alias, value: value, itemType: itemType })
    }

    delete = () => {
        deleteProjectSetting({ itemType: this.state.itemType, id: this.state.id }).then(response => {
            alert('This item is deleted. Refresh view.')
        })
    }

    deleteChildItem = (childOptionType, childOptionId) => {
        deleteProjectSetting({ itemType: childOptionType, id: childOptionId }).then(response => {
            this.refresh()
        })
    }

    attach = (itemType, id) => {
        attachProjectSetting({
            itemType: this.state.itemType,
            id: this.state.id,
            subItemType: itemType,
            subItemId: id
        }).then(() => {
            this.refresh()
        })
    }

    detach = (itemType, id) => {
        detachProjectSetting({
            itemType: this.state.itemType,
            id: this.state.id,
            subItemType: itemType,
            subItemId: id
        }).then(() => {
            this.refresh()
        })
    }

    openMoreSettings = () => {
        this.setState({ moreSettings: true })
    }

    render() {
        const { classes } = this.props
        const { id, fields, breadcrumbs, itemType, moreSettings, previousPayload, attachableItems, isLoading } = this.state

        return (
            <div className={classes.root}>
                <div className={classes.container}>
                    <Grid container spacing={1}>
                        <Grid item xs={10}>
                            {breadcrumbs && breadcrumbs.length > 0 && (
                                <ProjectBreadcrumb breadcrumbs={breadcrumbs} update={this.update} previousPayload={previousPayload} />
                            )}
                            {!(breadcrumbs && breadcrumbs.length > 0) && <div style={{ lineHeight: '35px' }}>All items</div>}
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            {!isLoading && (
                                <Tooltip title="Update">
                                    <IconButton aria-label="Update" onClick={this.refresh}>
                                        <FontAwesomeIcon size="xs" icon={['fal', 'redo']} />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {isLoading && (
                                <Tooltip title="Updating">
                                    <IconButton aria-label="Updating">
                                        <FontAwesomeIcon size="xs" icon={['fal', 'spinner-third']} spin className={classes.loadingSpinner} />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Grid>
                    </Grid>
                    {fields &&
                        fields.map((field, key) => {
                            // TODO: remove when API support for loan calculator option
                            if (field.alias === 'type') {
                                field.options.push({ value: 'loanCalculator', label: 'Loan calculator' })
                            }
                            return (
                                <React.Fragment key={key}>
                                    {(field.type === 'text' || field.type === 'number') && <ProjectTextField {...field} id={id} save={this.save} />}

                                    {field.type === 'select' && <ProjectSelectField {...field} id={id} save={this.save} />}

                                    {field.type === 'subItems' && (
                                        <ProjectSubItems
                                            {...field}
                                            update={this.update}
                                            id={id}
                                            save={this.save}
                                            create={this.create}
                                            onChildItemValueChanged={this.onChildItemValueChanged}
                                            attach={this.attach}
                                            detach={this.detach}
                                            createChildItem={this.createChildItem}
                                            deleteChildItem={this.deleteChildItem}
                                        />
                                    )}
                                </React.Fragment>
                            )
                        })}
                    {id && !moreSettings && (
                        <Button variant="outlined" className={classes.moreButton} onClick={() => this.openMoreSettings()}>
                            <FontAwesomeIcon size="xs" icon={['fal', 'ellipsis-v']} />
                        </Button>
                    )}
                    {id && moreSettings && (
                        <Button variant="outlined" color="secondary" size="small" className={classes.button} onClick={() => this.delete()}>
                            Delete this item
                        </Button>
                    )}
                </div>
            </div>
        )
    }
}

AdminProjectSettings.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AdminProjectSettings)
